import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Form8858TextualinfoService {

  constructor(private http: HttpClient) { }

  private buildHttpParams(params: Record<string, any>): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key,
          typeof value === 'object' && !(value instanceof Date) ? JSON.stringify(value) : String(value)
        );
      }
    });
    return httpParams;
  }

  private buildFormData(params: Record<string, any>): string {
    const formData: string[] = [];
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        if (value !== undefined) {
          formData.push(encodeURIComponent(key) + '=' + encodeURIComponent(
            value === null ? '' :
            typeof value === 'object' ? JSON.stringify(value) : value
          ));
        }
      }
    }
    return formData.join('&');
  }

  private getPostHttpOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true
    };
  }

  /**
   * Generic load JSON - action codes: f5sne6, y5ypqx, 6tbecb, mpx16c, 3527y2, a0gmzp, zkn7je, kbuwei, 3ucwjb, 6eyqnz
   */
  loadJsonObject(
    baseUrl: string,
    params: Record<string, any>,
    globalService: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const merged = _.merge({}, globalService?.globalParams || globalService || {}, params);
    return this.http.get(url, {
      params: this.buildHttpParams(merged),
      withCredentials: true
    });
  }

  /**
   * Save Schedule NA - action_code=7990pd (same as AngularJS scheduleGGroupObjFactory.saveScheduleNA).
   * Payload matches AngularJS exactly: _.merge({}, GlobalService.globalParams, filterParams)
   * then extend with jsonObj, jsonSettings, and process_name.
   */
  saveScheduleNA(
    baseUrl: string,
    settings: any[],
    details: { addrows: any[]; editrows: any[]; removerows: any[] },
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=7990pd`;
    const g = globalService || {};
    const f = filterParams || {};

    let params: any = _.merge({}, g, f);
    params = _.extend({ jsonObj: JSON.stringify(details) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(settings) }, params);
    params.process_name = 'Schedule_NA_Save';

    return this.http.post(url, this.buildFormData(params), this.getPostHttpOptions());
  }

  /**
   * Save Schedule G - action_code=h609oa (same as AngularJS scheduleGGroupObjFactory.saveScheduleG).
   * Payload matches AngularJS exactly: _.merge({}, GlobalService.globalParams, filterParams)
   * then extend with jsonObj, jsonSettings, and process_name.
   */
  saveScheduleG(
    baseUrl: string,
    settings: any[],
    details: { addrows: any[]; editrows: any[]; removerows: any[] },
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=h609oa`;
    const g = globalService ?? {};
    const f = filterParams ?? {};

    let params: any = _.merge({}, g, f);
    params = _.extend({ jsonObj: JSON.stringify(details) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(settings) }, params);
    params.process_name = 'Schedule_G_Save';

    return this.http.post(url, this.buildFormData(params), this.getPostHttpOptions());
  }
}
